import { DateTime } from 'luxon';
import ContentCopy from '@mui/icons-material/ContentCopy';
import Edit from '@mui/icons-material/Edit';

const formatExpires = (expiresAt: string | null | undefined): string => {
  if (!expiresAt) return 'Never';
  try {
    return DateTime.fromISO(expiresAt).toFormat('dd LLL, yyyy');
  } catch {
    return expiresAt;
  }
};

const generateRows = (
  tokens: Keys[],
  onDelete: (token: Keys) => void,
  onCopyKey: (token: Keys) => void,
  locationIdToName?: Record<string, string>,
  onEdit?: (token: Keys) => void
): TableRow[] =>
  tokens.map((token) => {
    const ids: string[] = Array.isArray(token.locationIds) ? token.locationIds : [];
    const isClientKey = ids.length > 0;

    const actions: TableCellAction['data'] = [
      {
        type: 'other',
        icon: ContentCopy,
        linkData: {
          onClick: () => {
            onCopyKey(token);
          }
        }
      }
    ];

    if (isClientKey && onEdit) {
      actions.push({
        type: 'edit',
        icon: Edit,
        linkData: {
          onClick: () => {
            onEdit(token);
          }
        }
      });
    }

    actions.push({
      type: 'delete',
      linkData: {
        onClick: () => {
          onDelete(token);
        }
      }
    });

    const action: TableCellAction = {
      type: `action`,
      data: actions
    };

    const keyType = isClientKey ? 'Client' : 'Legacy';
    const location =
      ids.length === 0
        ? '—'
        : ids.map((id) => locationIdToName?.[id] ?? id).join(', ');

    const payload: TableRow = {
      name: token.name ?? '',
      keyType,
      location,
      expires: formatExpires(token.expiresAt ?? null),
      createdBy: token.createdBy ?? '—',
      createdAt: DateTime.fromISO(token.createdAt).toFormat('dd LLL, yyyy hh:mm:ss'),
      action
    };

    return payload;
  });

export default generateRows;
